import { render, staticRenderFns } from "./service-categories.vue?vue&type=template&id=b8432fa4&"
import script from "./service-categories.vue?vue&type=script&lang=js&"
export * from "./service-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports